import './App.css';
import './react-tabs.css';
import {
  useEnt,
  useAreas,
  useEnts,
  useFind,
  useHistory,
  useHistories,
  haConfig,
  wsSendCommand,
} from './hooks/useHomeAssistantCore.js';
import {
  useLight,
  useLock,
  useScene,
  useRunnings,
  useDoors,
  useWindows,
  useGarageDoors,
  useMotions,
  useTimesToday,
} from './hooks/useHomeAssistant.js';

import { useRateBins } from './EnergyFlow.jsx';

import resolveRate from './utilityRates.js';

import { useEffect, useState, React } from 'react';

import powerData from './power.json';

import { hvacPowerSinks } from './houseConfig.js';

import { useInterval } from 'react-use';

import { CameraCard, LightCard, AccessoryCard, WideAccessoryCard, SectionLayout /*TemperatureIcon*/ } from './homekit-react-components/src/';

import { HuePicker } from 'react-color';

import dooropen from './images/door-open.svg';
import doorclosed from './images/door-closed.svg';
import lockopen from './images/lock-open.svg';
import lockclosed from './images/lock-closed.svg';
import garageopen from './images/garage-open.svg';
import garageclosed from './images/garage-closed.svg';
import windowopen from './images/window-open.svg';
import windowclosed from './images/window-closed.svg';
import energyon from './images/energy-on.svg';
import energyoff from './images/energy-off.svg';
import homeicon from './images/home.svg';
import alarmicon from './images/alarm.svg';
import motoricon from './images/motor.svg';

import lightbulbicon from './images/light-bulb.svg';
import dishwasher from './images/dishwasher-2-svgrepo-com.svg';
import laundry from './images/laundry-svgrepo-com-2.svg';

import battery100 from './images/battery-100-svgrepo-com.svg';
import battery88 from './images/battery-088-svgrepo-com.svg';
import battery75 from './images/battery-075-svgrepo-com.svg';
import battery62 from './images/battery-062-svgrepo-com.svg';
import battery50 from './images/battery-050-svgrepo-com.svg';
import battery37 from './images/battery-037-svgrepo-com.svg';
import battery25 from './images/battery-025-svgrepo-com.svg';
import battery12 from './images/battery-012-svgrepo-com.svg';
import battery0 from './images/battery-000-svgrepo-com.svg';



import chargerplugged from './images/charger-plugged.svg';
import chargerunplugged from './images/charger-unplugged.svg';
// import wateroff from './images/water-svgrepo-com-3.svg';
import wateron from './images/water-svgrepo-com-4.svg';

import Gradient from 'javascript-color-gradient';

import { ErrorBoundary } from 'react-error-boundary';

const actionRequiredColor = 'red';

const exteriorAreaIds = [
  'garage',
  'front_yard',
  'front_porch',
  'balcony',
  'sunroom',
  'back_yard',
  'back_porch',
  'parking_area',
  'cars',
];

function mapTemperature(v) {
  if (v === 'unavailable') {
    return undefined;
  }
  if (v === 'unknown') {
    return undefined;
  }
  return parseFloat(parseFloat(v).toFixed(1));
}

/*
function useAgoString(ent, key='last_changed') {
  const [counter, setCounter] = useState(0);
  let interval = 5;
  useEffect(() => {
    if (!ent) {
      return;
    }
    const iv = setInterval(() => {
      setCounter(counter + 1);
    }, 1000 * interval);

    return () => {
      clearInterval(iv);
    };
  },[ent, interval, counter]);

  if (!ent) {
    return '';
  }
  if (ent[key]) {
    return getAgoString(ent[key]);
  }
  return '';
}
*/

function getAgo(date) {
  const now = Date.now();
  const then = new Date(date).getTime();
  const delta = (now-then)/1000;
  const absDelta = Math.abs(delta);
  if (absDelta < 5) {
    return [delta,'','now',''];
  }
  const in_ = delta > 0 ? '' : 'in ';
  const ago = delta > 0 ? ' ago' : '';
  let value = delta.toFixed(0);
  let units = 's';
  const test = 0;//4;
  if (absDelta > 7*86400) {
    units = '';
    value = 'a while';
  } else if (absDelta > 86400) {
    units = 'd';
    value = (absDelta/86400).toFixed(2+test);
  } else if (absDelta > 3600) {
    units = 'h';
    value = (absDelta/3600).toFixed(1+test);
  } else if (absDelta > 60) {
    units = 'm';
    value = (absDelta/60).toFixed(1+test);
  }

  return [delta,in_,value,units,ago];
}

function getAgoString(argument, placeholder='-') {
  if (!argument) {
    return placeholder;
  }
  return getAgo(argument.last_changed ? argument.last_changed : argument).slice(1).join('').replace('ago','');
}

function getDisplayName(ent,stripNames) {
  if (!ent) {
    return '?';
  }
  let area_strip = '';
  let area_strip_alt = '';
  if (stripNames && ent.area && ent.area.name) {
    area_strip = ent.area.name + ' ';
  }
  if (area_strip.match(/\bbedroom/i)) {
    area_strip_alt = new RegExp(area_strip.replace(/\bbedroom/i,'room'),'i');
  } else if (area_strip.match(/\broom/i)) {
    area_strip_alt = new RegExp(area_strip.replace(/\broom/i,'bedroom'),'i');
  }
  let name = ent.attributes.friendly_name;
  // if (ent.config.platform === 'powerwall') {
    // name = 'Powerwall ' + name;
  // }
  name = name
    .replace(/Zo(e|ë)/i,'Z')
    .replace(/Kate/i,'K')
    .replace(/Alex/i,'A')
    .replace(/Parents'?\s*(bedroom|bed|room)?/i,'MBR')
    .replace('Hamilton Way ', '')
    .replace(/Water heater diagnostic bridge/,'Water Heater')
    .replace(/Temperature/i,'Temp')
    .replace(area_strip, '')
    .replace(area_strip_alt, '');

  name = name.substring(0,1).toUpperCase() + name.substring(1); 

  return name;
}

function ReloadingCameraCard({entity_id}) {
  // const [targetRef, visible] = useVisible();
  const interval = 5;
  const [counter, setCounter] = useState(0);
  const ent = useEnt(entity_id);

  useEffect(() => {
    const iv = setInterval(() => {
      setCounter(counter + 1);
    }, 1000 * interval);

    return () => {
      clearInterval(iv);
    };
  },[interval, counter]);

  if (ent === null || ent === undefined) {
    return null;
  }

  return (
    <CameraCard
      skipLoading={true}
      name={ent.attributes.friendly_name.replace(/ High( Resolution Channel)?$/,'')}
      previewImageSrc={haConfig.urlBase.replace(/\/$/,'') + ent.attributes.entity_picture + '&_ts=' + Date.now()}
    />
  );
}

function Energy({entity_id}) {
  const ent = useEnt(entity_id);
  let history = useHistory(entity_id,0);
  if (history === undefined || !history.data || !history.data.length) {
    return null;
  }
  let info = '';
  const cleanHistory = history.data.filter(r => !isNaN(r.state));
  if (cleanHistory.length === 0) {
    return null;
  }
  // console.log({history,cleanHistory});
  //let info = parseFloat(ent.state).toFixed(1) + ent.attributes.unit_of_measurement;

  if (ent.area_id !== 'cars') {
    let startValue = parseFloat(cleanHistory[0].state);
    const endValue = parseFloat(ent.state);
    const difference = endValue - startValue;
    info += '' + difference.toFixed(1) + ' kWh';

    let costAccumulator = 0;
    for (let i=1;i<cleanHistory.length; i++) {
      const date = new Date(cleanHistory[i].last_changed);
      const value = parseFloat(cleanHistory[i].state);
      const rate = resolveRate(date);
      if (rate !== null) {
        const delta = value - startValue;
        costAccumulator += ((rate.rate)*delta);
      }
      startValue = value;
    }
    info += ' $' + costAccumulator.toFixed(2) + ' today';
  }

  return (
    <AccessoryCard
      name={getDisplayName(ent)}
      state={info}
      isActive={true}
      stale={getStale(ent)}
      handlePress={() => pressEnt(ent)}
      iconActive={<ImageIcon backgroundColor={'#919ccd'} src={energyon} />}
    />
  );
}

function pressEnt(ent) {
  console.log(ent);
  alert(JSON.stringify(ent,null,2));
}

function CarCharger({entity_id, stripNames = true}) {
  // binary_sensor.bakah_charger
  // sensor.bakah_battery
  const ent = useEnt(entity_id);
  const battery_ent = useEnt(entity_id.replace(/^binary_/,'').replace(/_charger$/,'_battery'));
  // console.log({entity_id,ent,battery_ent});
  if (ent === null) {
    return null;
  }
  const on = ent.state==='on';
  // if (battery_ent === null || ent === null) {
  //   return null;
  // }
  return (
    <AccessoryCard
      name={getDisplayName(ent,stripNames).replace(' Charger', '') + ' ' + (on?'Plugged in':'Unplugged')}
      state={battery_ent ? (battery_ent.state + '%'):'?'}
      stale={getStale(ent)}
      isActive={true}
      handlePress={() => pressEnt(ent)}
      iconActive={<ImageIcon backgroundColor={on?'#919ccd':actionRequiredColor} src={ent.state === 'on' ? chargerplugged : chargerunplugged} />}
    />
  );
}

function LastRun({entity_id}) {
  const ent = useEnt(entity_id);
  return (
    <AccessoryCard
      name={getDisplayName(ent,true)}
      state={getAgoString(ent.last_changed)}
      stale={getStale(ent)}
      isActive={true}
      handlePress={() => pressEnt(ent)}
      iconActive={<ImageIcon backgroundColor={'#919ccd'} src={alarmicon} />}
    />
  );
}

const a_table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
const b_table = a_table.split(' ').map(function(s){ return parseInt(s,16); });
function b_crc32(str) {
  var crc = -1;
  for(var i=0, iTop=str.length; i<iTop; i++) {
      crc = ( crc >>> 8 ) ^ b_table[( crc ^ str.charCodeAt( i ) ) & 0xFF];
  }
  return (crc ^ (-1)) >>> 0;
}


function getStales(ents) {
  if (!ents) {
    return '';
  }
  const sorted = ents.filter(e => e !== undefined && e !== null).sort((a,b) => a.last_changed < b.last_changed ? 1 : -1);
  return getStale(sorted[0]);
}


function getStale(ent) {
  if (!ent) {
    return '?';
  }
  if (ent.last_updated) {
    const lu = new Date(ent.last_updated);
    const delta = Date.now() - lu.getTime();
    if (delta < 35000) {
      return '✓';
    } else {
      return getAgo(lu).slice(1).join('').replace(' ago','');
    }
  }

  return '?';
}

function getEntNextUpdate(ent) {
  if (!ent) {
    return 100;
  }
  const date = ent.last_changed || ent.last_updated;
  const now = Date.now();
  const then = new Date(date).getTime();
  const delta = (now-then)/1000;
  const absDelta = Math.abs(delta);
  if (absDelta < 300) {
    return 1000;
  }
  if (absDelta < 3600) {
    return 10000;
  }
  const pseudorand = b_crc32(ent.entity_id) % 10000;
  return 10000 + pseudorand;
}

function useEntsUpdater(ents) {
  const sorted = ents.filter(e => e !== undefined && e !== null).sort((a,b) => a.last_changed < b.last_changed ? 1 : -1);
  useEntUpdater(sorted[0]);
  return sorted[0];
}

function useEntUpdater(ent) {
  const [tick, setTick] = useState(0);
  useInterval(() => { setTick(tick+1); }, getEntNextUpdate(ent));
}

function Entity({entity_id,stripNames=true}) {
  const ent = useEnt(entity_id);
  useEntUpdater(ent);

//   const use_sequence_to_try_for_accurate_timestamps = false;
//   const [sequence, setSequence] = useState(0);
//   let interval = 1000;
//   const now_ts = (new Date().getTime());
//   let change_ts = now_ts;
//   if (ent) {
//     change_ts = (new Date(ent.last_changed)).getTime();
//   }
//   const absDelta = Math.abs(change_ts - now_ts);
//   if (absDelta > 60000) {
//     interval = 60000;
//   }
//   useEffect(() => {
//     if (use_sequence_to_try_for_accurate_timestamps) {
//       const iv = setTimeout(() => {
//         setSequence(sequence + 1);
//       }, 1000 * interval);
// 
//       return () => {
//         clearTimeout(iv);
//       };
//     }
//   },[interval, sequence]);
// 

  if (!ent) {
    return null;
  }

  if (entity_id.match(/^light\./)) {
    return <Light entity_id={entity_id} stripNames={stripNames} />;
  }
  if (entity_id.match(/^scene\./)) {
    return <Scene entity_id={entity_id} stripNames={stripNames} />;
  }
  if (entity_id.match(/^camera\./)) {
    return (<ReloadingCameraCard entity_id={entity_id} stripNames={stripNames} />);
  }
  if (entity_id.match(/^sensor\..+next_alarm$/)) {
    return (<Alarm entity_id={entity_id} stripNames={stripNames} />);
  }
  if (entity_id.match(/^lock\./)) {
    return (<Lock entity_id={entity_id} stripNames={stripNames} />);
  }
  if (ent && ent.attributes && ent.attributes.hvac_action) {
    return (<Climate entity_id={entity_id} stripNames={stripNames} />);
  }
  if (ent && ent.attributes && ent.attributes.state_class==='total' && ent.attributes.unit_of_measurement === 'kWh') {
    return (<Energy entity_id={entity_id} />);
  }

  if (ent.attributes && ent.attributes.friendly_name && ent.attributes.friendly_name.match(/Last Run/i)) {
    return (<LastRun entity_id={entity_id} />);
  }



  const mi = [
    [0,battery0],
    [12,battery12],
    [25,battery25],
    [37,battery37],
    [50,battery50],
    [62,battery62],
    [75,battery75],
    [88,battery88],
    [100,battery100],
  ];
  let batticon = battery0;

  const open = ent.state === 'on';
  let info = '';
  let on;

  switch (ent.attributes.device_class) {
    case 'temperature':
      return (<Temperature entity_id={entity_id} stripNames={stripNames} />);
    case 'plug':
      if ((ent.device) && (ent.device.manufacturer === 'Tesla')) {
        return (<CarCharger entity_id={entity_id} />);
      }
      return (
        <AccessoryCard
          name={getDisplayName(ent,stripNames)}
          state={getAgoString(ent.last_changed)}
          isActive={true}
          stale={getStale(ent)}
          handlePress={() => pressEnt(ent)}
          iconActive={<ImageIcon backgroundColor={ent.state==='on'?'#919ccd':actionRequiredColor} src={ent.state === 'on' ? chargerplugged : chargerunplugged} />}
        />
      );
    case 'water':
      on = parseFloat(ent.state) > 0;
      return (
        <AccessoryCard
          name={getDisplayName(ent,stripNames)}
          state={parseFloat(ent.state).toFixed(1) + ' ' + ent.attributes.unit_of_measurement}
          stale={getStale(ent)}
          isActive={true}
          handlePress={() => pressEnt(ent)}
          iconActive={<ImageIcon backgroundColor={on?(ent.entity_id.match(/hot/i)?'red':'blue'):'gray'} src={wateron} />}
        />
      );
    case 'timestamp':
      return (
        <AccessoryCard
          name={getDisplayName(ent,stripNames)}
          state={ent.state === 'unknown' ? '?' : getAgoString(ent.state)}
          stale={getStale(ent)}
          isActive={true}
          handlePress={() => pressEnt(ent)}
          iconActive={<ImageIcon backgroundColor={ent.state==='on'?'#919ccd':actionRequiredColor} src={ent.state === 'on' ? chargerplugged : chargerunplugged} />}
        />
      );
    case 'battery':
      if (ent.attributes.state_class !== 'measurement') {
        break;
      }
      mi.map(a => batticon = parseInt(ent.state) >= a[0]?a[1]:batticon);

      return (
        <AccessoryCard
          name={getDisplayName(ent,stripNames)}
          state={ent.state === 'unknown'?'No data' : parseFloat(ent.state).toFixed(1) + ent.attributes.unit_of_measurement}
          isActive={true}
          stale={getStale(ent)}
          handlePress={() => pressEnt(ent)}
          iconActive={<ImageIcon backgroundColor={'#919ccd'} src={batticon} />}
        />
      );
    case 'running':
      return (
        <AccessoryCard
          name={getDisplayName(ent,stripNames).replace(/Compressor/,'')}
          state={(ent.state === 'on' ? 'Running ':'Idle ')}
          isActive={ent.state === 'on'}
          stale={getStale(ent)}
          handlePress={() => pressEnt(ent)}
          iconActive={<ImageIcon backgroundColor={'#919ccd'} src={motoricon} />}
        />
      );
    case 'power':
      if (ent.entity_id.match(/^binary_sensor\./)) {
        break;
      }
      info = parseFloat(ent.state).toFixed(1) + ent.attributes.unit_of_measurement;
      if (info !== null) {
        const rate = resolveRate(new Date());
        if (rate !== null) {
          const usage = parseFloat(ent.state);
          const burn = usage * rate.rate;
          info += ' $' + burn.toFixed(2) + '/hr';
        }
        if (Math.abs(parseFloat(ent.state)) < 0.05) {
          info = 'Idle';
        }
      }
      return (
        <AccessoryCard
          name={getDisplayName(ent,stripNames)}
          state={info}
          isActive={true}
          stale={getStale(ent)}
          handlePress={() => pressEnt(ent)}
          iconActive={<ImageIcon backgroundColor={'#919ccd'} src={energyon} />}
        />
      );
    case 'energy':
      return (<Energy entity_id={entity_id} />);
    case 'duration':
        return (
          <AccessoryCard
            name={getDisplayName(ent,stripNames)}
            state={'minutes'}
            isActive={true}
            stale={getStale(ent)}
            handlePress={() => pressEnt(ent)}
            iconActive={<GenericIcon text={(ent.state/60).toFixed(1)} />}
          />
        );
    case 'voltage':
    case 'frequency':
      if (entity_id.match(/^binary_sensor\./)) {
        return (
          <AccessoryCard
            name={getDisplayName(ent,stripNames)}
            state={ent.state === 'on' ? 'On' : 'Off'}
            isActive={true}
            stale={getStale(ent)}
            handlePress={() => pressEnt(ent)}
            iconActive={<ImageIcon backgroundColor={'#919ccd'} src={ent.state === 'on'?energyon:energyoff} />}
          />
        );
      }
      return (
        <AccessoryCard
          name={getDisplayName(ent,stripNames)}
          state={parseFloat(ent.state).toFixed(1) + ent.attributes.unit_of_measurement}
          isActive={true}
          stale={getStale(ent)}
          handlePress={() => pressEnt(ent)}
          iconActive={<ImageIcon backgroundColor={'#919ccd'} src={energyon} />}
        />
      );
    case 'door':
    case 'garage_door':
    case 'window':
      // eslint-disable-next-line
      const portalIcons = {
        'door': {open: dooropen, closed: doorclosed},
        'garage_door': {open: garageopen, closed: garageclosed},
        'window': {open: windowopen, closed: windowclosed},
      };
      // eslint-disable-next-line
      const icons = ent.attributes && ent.attributes.device_class ? portalIcons[ent.attributes.device_class] : {open:null,closed:null};
      // eslint-disable-next-line
      const icon = open ? icons.open : icons.closed;
      return (
        <AccessoryCard
          name={getDisplayName(ent,stripNames)}
          state={open ? 'Open': 'Closed' + ' ' + getAgoString(ent.last_changed)}
          isActive={true}
          stale={getStale(ent)}
          handlePress={() => pressEnt(ent)}
          iconActive={<ImageIcon backgroundColor={'#919ccd'} src={icon} />}
          iconInactive={<ImageIcon backgroundColor={'#919ccd'} src={icon} />}
        />
      );
    default:
      break;
  }
  return (
    <AccessoryCard
      name={getDisplayName(ent,stripNames)}
      state={ent.attributes.device_class || '?'}
      isActive={true}
      stale={getStale(ent)}
      handlePress={() => pressEnt(ent)}
      iconActive={<GenericIcon backgroundColor='orange' color='black' text={ent.state} />}
      iconInactive={<GenericIcon text={'?'} />}
    />
  );
}

function ImageIcon({src,backgroundColor='white'}) {
  return <GenericIcon backgroundColor={backgroundColor} text={<img src={src} style={{height:30,width:30}} />} />;
}

function GenericIcon({text,color='lightgrey',backgroundColor='green'}) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      width: '2.8rem',
      height: '2.8rem',
      backgroundColor: backgroundColor,
      borderRadius: 45,
    }}>
      <div style={{
        textAlign: 'center',
        width: '100%',
        fontSize: '1.25rem',
        fontWeight: 'bold',
        color: color,
      }}>
        {text}
      </div>
    </div>
  );
}

function Temperature({entity_id, stripNames}) {
  const ent = useEnt(entity_id);
  useEntUpdater(ent);
  // const [ on, setOn ] = useState(ent.state === 'on');
  if (!ent) {
    return null;
  }

  if (ent.state === 'unavailable') {
    return null;
  }

  const tempColor = temperatureToColor(ent.state);

  return (
    <AccessoryCard
      name={getDisplayName(ent,stripNames)}
      state={mapTemperature(ent.state) !== undefined ? (mapTemperature(ent.state) + ent.attributes.unit_of_measurement) : 'Inactive'}
      stale={getStale(ent)}
      handlePress={() => pressEnt(ent)}
      isActive={mapTemperature(ent.state) !== undefined}
      iconActive={<GenericIcon color='white' backgroundColor={tempColor} text={parseFloat(ent.state).toFixed(0)} />}
    />
  );
}

function Climate({entity_id,stripNames}) {
  const ent = useEnt(entity_id);
  useEntUpdater(ent);

  // const histories = useHistories(hvacPowerSinks[entity_id].energy,0);
  const histories = useRateBins(hvacPowerSinks[entity_id].energy[0], false);

  const times = useTimesToday(entity_id,(d) => d?.attributes?.hvac_action);

  if (!ent) {
    return null;
  }

  if (!ent.attributes.hvac_action) {
    return null;
  }

  const total_usage = null;
  // console.log('Climate',{entity_id,ent,histories});

  let modeColor;
  let modeLabel;
  let unit = '°F';

  let temp = '';
  if (ent.attributes.temperature !== null) {
    temp += ' — ' + ent.attributes.temperature + unit;
  }
  switch (ent.attributes.hvac_action) {
    case 'heating':
      modeColor = 'red';
      modeLabel = 'Heat' + temp;
      break;
    case 'cooling':
      modeColor = 'blue';
      modeLabel = 'Cool' + temp;
      break;
    default:
      modeColor = 'gray';
      modeLabel = 'Idle' + temp;
      break;
  }
  let active = 0;
  let activitySummary = '';
  if (times.heating) {
    active += times.heating;
  }
  if (times.cooling) {
    active += times.cooling;
  }
  if (active) {
    activitySummary = <div>{(active/3600).toFixed(1) + 'h today'}</div>;
  }

  let spent = 0;
  if (histories.costs) {
    for (let k in histories.costs) {
      spent += histories.costs[k];
    }
  }
  const costs = '$' + spent.toFixed(2);

  return (
    <AccessoryCard
      name={<span>{costs} {getDisplayName(ent,stripNames)}{activitySummary}</span>}
      isActive={true}
      stale={getStale(ent)}
      state={modeLabel}
      handlePress={() => pressEnt(ent)}
      iconActive={<GenericIcon color='white' backgroundColor={modeColor} text={ent.attributes.current_temperature + unit} />}
    />
  );
}

function Alarm({entity_id,stripNames}) {
  const ent = useEnt(entity_id);
  useEntUpdater(ent);

  if (!ent) {
    return null;
  }

  if (!entity_id.match(/next_alarm$/)) {
    return null;
  }

  let next = '-';
  if (ent.state !== 'unknown') {
    next = (new Date(ent.state)).toLocaleTimeString();
  }

  return (
    <AccessoryCard
      name={getDisplayName(ent,stripNames)}
      isActive={true}
      stale={getStale(ent)}
      state={next}
      iconActive={<ImageIcon backgroundColor={'lightblue'} src={alarmicon} />}
    />
  );
}


function Lock({entity_id,stripNames}) {
  const [ent,toggle] = useLock(entity_id);
  if (!ent) {
    return null;
  }

  return (
    <AccessoryCard
      name={getDisplayName(ent,stripNames)}
      // handlePress={() => alert(entity_id + '\n' + JSON.stringify(ent,null,2))}
      handlePress={() => toggle()}
      isActive={true}
      stale={getStale(ent)}
      state={ent.state==='locked'}
      iconActive={<ImageIcon backgroundColor={'pink'} src={ent.state==='locked'?lockclosed:lockopen} />}
    />
  );
}

function makeToggle(ent,target=null) {
  let setTo = target ? target : (ent.state === 'off' ? 'on' : 'off');
  return () => {
    wsSendCommand({
      'type': 'call_service',
      'domain': 'light',
      'service': (setTo === 'on') ? 'turn_on' : 'turn_off',
      'target': {
        'entity_id': ent.entity_id,
      },
    }, () => null);
  };
}

function LightsCluster({entity_ids,name}) {
  const ents = useEnts(entity_ids).filter(e => e && e.state !== 'unavailable');
  useEntsUpdater(ents);
  if (ents.length === 0) {
    return null;
  }
  const ons = ents.filter(e => e.state === 'on');
  const offs = ents.filter(e => e.state === 'off');
  const allOn = !offs.length;
  const allOff = !ons.length;

  const onPowers = ons.map(e => powerForLight(e.entity_id)).reduce((a, b) => a + b, 0);

  let color = 'gray';
  let state = ons.length + ' of ' + ents.length;
  let actions = [];
  if (allOn) {
    color = 'yellow';
    state = 'All ' + ons.length + ' on';
    if (ons.length === 1) {
      state = 'On';
    } else if (ons.length === 2) {
      state = 'Both on';
    }
    actions = ons.map(e => makeToggle(e));
  } else if (allOff) {
    color = 'gray';
    state = 'All ' + offs.length + ' off';
    if (offs.length === 1) {
      state = 'Off';
    } else if (offs.length === 2) {
      state = 'Both off';
    }
    actions = offs.map(e => makeToggle(e));
  } else {
    actions = ents.map(e => makeToggle(e, 'off'));
  }

  return (
    <AccessoryCard
      name={name}
      // handlePress={() => alert(entity_ids.join('\n') + '\n' + JSON.stringify(ents,null,2))}
      handlePress={() => actions.map(a => a())}
      isActive={!allOff}
      state={state}
      stale={getStales(ents) + ' ' + (onPowers>0?(onPowers.toFixed(0)+'W'):'')}      
      iconActive={<ImageIcon backgroundColor={color} src={lightbulbicon} />}
      iconInactive={<ImageIcon backgroundColor={color} src={lightbulbicon} />}
    />
  );
}

function Scene({entity_id,stripNames}) {
  const [ent, invokeScene] = useScene(entity_id);
  useEntsUpdater([ent]);
  // const ago = useAgoString(ent, 'state');
  // const [ on, setOn ] = useState(ent.state === 'on');

  if (!ent) {
    return null;
  }

  return (
    <AccessoryCard
      name={getDisplayName(ent,stripNames)}
      // handlePress={() => alert(entity_id + '\n' + JSON.stringify(ent,null,2))}
      handlePress={() => invokeScene()}
      stale={getStale(ent)}
      isActive={true}
      state={getAgoString(ent.state)}
      iconActive={<ImageIcon backgroundColor={'pink'} src={homeicon} />}
    />
  );
}

function getMostRecentChangeOrEmptyString(ents) {
  if (!ents.length) {
    return '';
  }
  const sorted_changes = ents.map(e => e.last_changed).filter(e => e !== undefined && e !== null).sort((a,b) => a < b ? 1 : -1);
  const most_recent_change = sorted_changes[0];
  return getAgoString(most_recent_change, '');
}

function AllMotions({exclude=[],include=[]}) {
  let ids = useMotions();
  if (exclude.length) {
    ids = ids.filter(i => !exclude.includes(i));
  }
  if (include.length) {
    ids = ids.filter(i => include.includes(i));
  }
  const now = Date.now();
  const motions = useEnts(ids)
    .filter(e => e && e.device)
    .filter(e => e.device.manufacturer !== 'ecobee Inc.' || (now - (new Date(e.last_changed)).getTime() < 5000))
    .filter(e => e.device.manufacturer !== 'Ubiquiti' || (now - (new Date(e.last_changed)).getTime() < 5000));
  useEntsUpdater(motions);

  const movings = motions
    .filter(e => e.state === 'on');

  let labelText = useAreaNamesForEnts(movings);
  // labelText += ' ' + getMostRecentChangeOrEmptyString(motions);

  return (
    <AccessoryCard
      name={'Motion'}
      isActive={!!movings.length}
      state={labelText}
      stale={getStales(motions)}
      iconActive={<ImageIcon backgroundColor={actionRequiredColor} src={dooropen} />}
      iconInactive={<ImageIcon backgroundColor={'green'} src={doorclosed} />}
    />
  );
}

function AllDoors({interior=undefined,notReadyColor=actionRequiredColor}) {
  const door_ids = useDoors();
  let doors = useEnts(door_ids)
    .filter(e => {
      if (e.device && e.device.manufacturer && e.device.manufacturer === 'Tesla') {
        return false;
      }
      return true;
    })
    .filter(e => {
      if (interior === true) {
        return !exteriorAreaIds.includes(e.area_id);
      } else if (interior === false) {
        return exteriorAreaIds.includes(e.area_id);
      } else {
        return true;
      }
  });
  useEntsUpdater(doors);

  let label = 'Doors';
  if (interior === true) {
    label = 'inside doors';
  } else if (interior === false) {
    label = 'exterior doors';
  }

  // const most_recently_changed = doors.sort((a,b) => a.last_changed > b.last_changed ? -1 : 1)[0];

  const opens = doors.filter(e => e.state === 'on');

  let labelText = doors.length + ' ' + label + ' closed';
  if (opens.length === 1) {
    labelText = '1 ' + (label.replace(/s$/,'')) + '';
  } else if (opens.length) {
    labelText = opens.length + ' ' + label + '';
  }

// console.log(most_recently_changed.attributes.friendly_name,getAgo(most_recently_changed.last_changed).slice(1).join(''));

  let openDoorNames = opens
    .map(e => e.attributes.friendly_name.replace(/(bedroom|room)/i,'').replace(/door/i,'').trim())
    .join(', ')
    .replace(/Parents/,'MBR')
    .replace(/Zo(e|ë)/i,'Z')
    .replace(/Kate/i,'K')
    .replace(/Alex/i,'A');

  // openDoorNames += ' ' + getMostRecentChangeOrEmptyString(doors);

  return (
    <AccessoryCard
      name={labelText}
      isActive={opens.length}
      state={openDoorNames}
      stale={getStales(doors)}
      iconActive={<ImageIcon backgroundColor={notReadyColor} src={dooropen} />}
      iconInactive={<ImageIcon backgroundColor={'green'} src={doorclosed} />}
    />
  );
}

function AllGarageDoors() {
  const door_ids = useGarageDoors();
  let ids = door_ids;
  const doors = useEnts(ids);
  const opens = doors.filter(e => e.state === 'on');

  const most_recently_changed = doors.sort((a,b) => a.attributes.last_tripped_time > b.attributes.last_tripped_time ? -1 : 1)[0];

  let labelText = 'Garage doors closed';
  if (doors.length === 1)   {
    labelText = 'Garage door closed';
  }
  if (opens.length) {
    labelText = `${opens.length} Garage doors open`;
    if (opens.length === 1) {
      labelText = `${opens[0].attributes.friendly_name} open`;
    }
  }

  let state = 'unknown';
  if (most_recently_changed && most_recently_changed.attributes) {
    state = getAgoString(most_recently_changed.attributes.last_tripped_time);
  }

  return (
    <AccessoryCard
      name={labelText}
      isActive={opens.length}
      state={state}
      stale={getStales(doors)}
      iconActive={<ImageIcon backgroundColor={actionRequiredColor} src={garageopen} />}
      iconInactive={<ImageIcon backgroundColor={'green'} src={garageclosed} />}
    />
  );
}

function AllRunnings() {
  const running_ids = useRunnings();
  const runnings = useEnts(running_ids);
  const ons = runnings.filter(e => e.state === 'on');

  return (
    <AccessoryCard
      name={ons.length ? (ons.length + ' running') : 'Nothing running'}
      isActive={ons.length}
      state={''}
      stale={getStales(runnings)}
      iconActive={<ImageIcon color='white' backgroundColor={actionRequiredColor} src={motoricon} />}
      iconInactive={<ImageIcon color='white' backgroundColor={'green'} src={motoricon} />}
    />
  );
}

function AllWindows() {
  const window_ids = useWindows();
  const windows = useEnts(window_ids);
  const opens = windows.filter(e => e.state === 'on');
  useEntsUpdater(windows);

  let openWindowNames = opens.map(e => e.attributes.friendly_name.replace(/windows?/i,'').trim()).join(', ');

  openWindowNames += ' ' + getMostRecentChangeOrEmptyString(windows);

  return (
    <AccessoryCard
      name={opens.length ? (opens.length + ' open windows') : (windows.length + ' windows closed')}
      isActive={opens.length}
      state={openWindowNames}
      stale={getStales(windows)}
      iconActive={<ImageIcon backgroundColor={actionRequiredColor} src={windowopen} />}
      iconInactive={<ImageIcon backgroundColor={'green'} src={windowclosed} />}
    />
  );
}

function useAreaNamesForEnts(ents) {
  const areas = useAreas();
  const areaMap = {};
  ents.map(e => {
    if (e.area && e.area.name) {
      areaMap[e.area_id] = true;
    } else {
      areaMap[e.entity_id.replace(/^binary_sensor\./,'')] = true;
    }
  });
  const activeAreas = Object.keys(areaMap);
  const sortedAreas = [];
  areas.ordered.map(a => {
    if (activeAreas.includes(a)) {
      sortedAreas.push(areas.areas[a].name);
    }
  });
  return sortedAreas
    .join(', ')
    .replace(/Parents/,'MBR')
    .replace(/Zo(e|ë)/i,'Z')
    .replace(/Kate/i,'K')
    .replace(/Alex/i,'A');
}

function AllLights({interior=false}) {
  const light_ids = useFind(/^light\./);
  const ents = useEnts(light_ids)
    .filter(e => {
      if (interior) {
        return !exteriorAreaIds.includes(e.area_id);
      } else {
        return exteriorAreaIds.includes(e.area_id);
      }
    });
  const most_recently_changed = useEntsUpdater(ents);

  const ons = ents.filter(e => e.state === 'on');
  const onLightNames = useAreaNamesForEnts(ons);

  const onPowers = ons.map(e => powerForLight(e.entity_id)).reduce((a, b) => a + b, 0);


  if (!ents.length) {
    return null;
  }

  let label = ons.length? (ons.length + ''):'No lights on';
  if (ons.length === 1) {
    label = '1 ';
  }
  if (interior) {
    label += ' inside';
  } else {
    label += ' outside';
  }

  const turnOnsOff = () => {
    alert(ons.map(e => e.attributes.friendly_name).join('\n'));
  };

  return (
    <AccessoryCard
      name={label}
      isActive={ons.length}
      state={onLightNames + ' ' + getAgoString(most_recently_changed)}
      handlePress={() => turnOnsOff()}
      stale={getStales(ents) + ' ' + (onPowers>0?(onPowers.toFixed(0)+'W'):'')}      
      iconActive={<ImageIcon backgroundColor={'white'} src={lightbulbicon} />}
      iconInactive={<ImageIcon backgroundColor={'grey'} src={lightbulbicon} />}
    />
  );
}

function powerForLight(entity_id) {
  const power = powerData[entity_id];
  if (!power === undefined) {
    return 0;
  }
  if (power?.good) {
    return power.value;
  } else {
    console.log('bad?',entity_id,power);
  }
  return 0;
}

function Light({entity_id,stripNames}) {
  const [ent, toggle, setBrightness] = useLight(entity_id);
  // const [ on, setOn ] = useState(ent.state === 'on');

  if (!ent) {
    return null;
  }

  const dimmable = ent.attributes.color_mode === 'brightness';

  return (
    <LightCard
      capabilities={{
        SUPPORT_BRIGHTNESS: dimmable,
      }}
      name={getDisplayName(ent,stripNames)}
      on={ent.state === 'on'}
      brightness={dimmable ? parseInt(100*ent.attributes.brightness/255): undefined}
      onBrightnessChange={(n) => setBrightness(n)}
      onToggle={() => toggle()}
    />
  );
}

function Area({entity_ids, area_id=null,label='',stripNames=true,filter=null}) {
  const areas = useAreas();
  let entities = useEnts(entity_ids);
  let title = label;
  if (area_id && areas.areas[area_id]) {
    title = areas.areas[area_id].name;
  }

  if (!(entity_ids && entity_ids.length)) {
    return null;
  }

  let filtered_entity_ids = entity_ids;
  if (filter) {
    filtered_entity_ids = entities.filter(e => filter(e)).map(e => e.entity_id);
  }

  if (!filtered_entity_ids.length) {
    return null;
  }

  return (
      <SectionLayout title={title}>
        {filtered_entity_ids.map(id => <Entity key={id} entity_id={id} stripNames={stripNames} />)}
      </SectionLayout>
  );
}

function rgbToHex(rgb) {
  return Object.keys(rgb)
    .map(k => parseInt(rgb[k],10).toString(16).padStart(2, '0'))
    .join('');
}

function LEDBar() {
  let [hex,setHex] = useState();

  useEffect(() => {
    const go = async () => {
      try {
        const p = await fetch('http://debian-homebridge.local:8080/');
        const json = await p.json();
        setHex('#' + rgbToHex(json.rgb));
      } catch (e) {
        setHex('#FF0000');
      }
    };
    go();
  }, []);

  if (hex === undefined) {
    return null;
  }

  return (
    <div style={{padding:40}}>
      <HuePicker height={20} color={hex} onChange={(ch) => setHex(ch.hex)} onChangeComplete={async (ch) => {
        try {
          await fetch(`http://debian-homebridge.local:8080/?r=${ch.rgb.r}&g=${ch.rgb.g}&b=${ch.rgb.b}`);
        } catch (e) {
          console.log('error',e);
        }
      } } />
    </div>
  );
}


const tMem = {};
function temperatureToColor(temperature, minTemperature=50, maxTemperature=160) {
  // Define the temperature range (adjust these values as needed)
  if (tMem[temperature] !== undefined) {
    return tMem[temperature];
  }

  if (isNaN(temperature)) {
    return '#d18105';
  }

  if (temperature === undefined) {
    return '#000000';
  }
  // Ensure the temperature is within the range
  temperature = Math.min(maxTemperature, Math.max(minTemperature, temperature));

  // Calculate the interpolation factor between 0 and 1
  const interpolationFactor = (temperature - minTemperature) / (maxTemperature - minTemperature);

  const span = Math.floor((maxTemperature - minTemperature) / 2) ;
  const index = 1 + parseInt((span * interpolationFactor).toFixed(0),10);
  const colorAtIndex = new Gradient()
    .setColorGradient(
      '#1de2e6',
      '#0d00e4',
      '#c40000',
      '#ff00ec',
      )
    .setMidpoint(span)
    .getColor(index);
  tMem[temperature] = colorAtIndex;
  return colorAtIndex;
}

function useEnergyDay(entity_id) {
  const history = useHistory(entity_id,0);
  if (history === undefined) {
    return 0;
  }
  if (history.data.length <= 1) {
    return 0;
  }
  return parseFloat(history.data[history.data.length - 1].state) - parseFloat(history.data[0].state);
}

function useStates(key_entity_ids) {
  const flip = Object.fromEntries(Object.entries(key_entity_ids).map(([key, value]) => [value, key]));
  const ents = useEnts(Object.keys(flip));
  const result = {};
  const entMap = {};
  ents.map(e => { result[flip[e.entity_id]] = e.state; entMap[flip[e.entity_id]] = e;});
  return [result, entMap];
}

function DishwasherCard() {
  const todayEnergy = useEnergyDay('sensor.dishwasher_total_energy');
  const keys = {
    status: 'sensor.dishwasher_status',
    phase: 'sensor.dishwasher_program_phase',
    elapsed: 'sensor.dishwasher_elapsed_time',
    remain: 'sensor.dishwasher_remaining_time',
    power: 'switch.dishwasher_power_on',
    last_run: 'sensor.dishwasher_last_run',
    water: 'sensor.dishwasher_water_consumption',
    measured_power: 'sensor.kc868_m16_panel_power_dishwasher',
  };
  const [states, ents] = useStates(keys);
  // console.log({states,ents});
  // const updateds = Object.values(ents).map(e => getAgo(e.last_updated)).sort();
  // const changed = Object.values(ents).map(e => getAgo(e.last_changed)).sort();
  // console.log({updateds,changed});

  let state;
  let color = '#919ccd';
  let extra = null;
  if (states.phase === 'unknown') {
    state = (<span>
              Idle,
              Run {getAgoString(states.last_run)} ago
            </span>);
  } else {
    color = 'pink';
    state = (<span>
             {ents?.phase?.attributes?.Localized}{' '}
             {states.water + 'gal'}
           </span>);
    extra = (<pre>{states.remain}m left</pre>);
  }

  return (
    <WideAccessoryCard
      // name={'Wide Card. Much typing and text extends across various places wonder how far it will go'}
      // state={'OnState goes here and extends.' /* must not extend past one line */ }
      name={'Dishwasher'}
      state={state}
      isActive={true || states['power'] !== 'off'}
      stale={getStale(ents['elapsed']) + ' ' + parseFloat(states['measured_power']||0).toFixed(0) + 'W'}
      handlePress={() => true}
      extra={extra}
      iconActive={<ImageIcon backgroundColor={color} src={dishwasher} />}
    />
  );
}


function WaterHeaterCard() {
  const todayEnergy = useEnergyDay('sensor.heat_pump_water_heater_total_energy');
  const times = useTimesToday('binary_sensor.esp_poe1_compressor');

  const keys = {
    measured_power: 'sensor.kc868_m16_subpanel_power_water_heater_and_circulator',
    alerts: 'sensor.esp_poe1_active_alerts',
    alert1: 'sensor.esp_poe1_alarm_1',
    ambient: 'sensor.esp_poe1_ambient_temperature',
    compressor: 'binary_sensor.esp_poe1_compressor',
    discharge: 'sensor.esp_poe1_discharge_temperature',
    evaporator: 'sensor.esp_poe1_evaporator_temperature',
    fan: 'sensor.esp_poe1_fan_speed',
    hot_water: 'sensor.esp_poe1_hot_water',
    suction: 'sensor.esp_poe1_suction_temperature',
    lower_tank: 'sensor.esp_poe1_lower_tank_temperature',
    upper_tank: 'sensor.esp_poe1_upper_tank_temperature',
    model_number: 'sensor.esp_poe1_model_number',
    power: 'sensor.esp_poe1_power',
    circulated: 'sensor.esphome_web_a8c7c4_circulated_hot_water',
    total_circulated: 'sensor.esphome_web_a8c7c4_total_circulated_hot_water',
    dispensed: 'sensor.esphome_web_a8c7c4_dispensed_hot_water',
    total_dispensed: 'sensor.esphome_web_a8c7c4_total_dispensed_hot_water',
  };
  const [states, ents] = useStates(keys);
  // console.log({states,ents});
  // const updateds = Object.values(ents).map(e => getAgo(e.last_updated)).sort();
  // const changed = Object.values(ents).map(e => getAgo(e.last_changed)).sort();
  // console.log({updateds,changed});
  let idle = states.compressor === 'off';
  let state = (
    <span>
     {(idle)?'Idle':'Running'},{' '}
     {states.upper_tank}ºF
     {' - '}
     {states.lower_tank}ºF
     </span>
  );
  let extra = null;
  if (times && times.on) {
    extra = (<pre>{(times.on/3600).toFixed(1)}h today</pre>);
  }

  return (
    <WideAccessoryCard
      // name={'Wide Card. Much typing and text extends across various places wonder how far it will go'}
      // state={'OnState goes here and extends.' /* must not extend past one line */ }
      name={'Water Heater'}
      state={state}
      isActive={true}
      stale={getStale(ents['power']) + ' ' + parseFloat(states['measured_power']||0).toFixed(0) + 'W'}
      handlePress={() => true}
      extra={extra}
      iconActive={<ImageIcon backgroundColor={'#919ccd'} src={wateron} />}
    />
  );
}

function LaundryCard({tag}) {
  const sn = {
    left: 'mv361755n',
    right: 'mv362191n',
  }[tag];
  const keys = {
    measured_power: `sensor.kc868_m16_panel_power_${tag}_laundry`,
    cycle: `sensor.${sn}_laundry_cycle`,
    delay_remain: `sensor.${sn}_laundry_delay_time_remaining`,
    last_run: `sensor.${tag}_laundry_last_run`,
    prewash: `binary_sensor.${sn}_laundry_washer_prewash`,
    remote_status: `binary_sensor.${sn}_laundry_remote_status`,
    loads_left: `sensor.${sn}_laundry_washer_smart_dispense_loads_left`,
    tank_status: `sensor.${sn}_laundry_washer_smart_dispense_tank_status`,
    machine_state: `sensor.${sn}_laundry_machine_state`,
    sub_cycle: `sensor.${sn}_laundry_sub_cycle`,
    time_remaining: `sensor.${sn}_laundry_time_remaining`,
    tumblenew_status: `sensor.${sn}_laundry_dryer_tumblenew_status`,
  };
  const energyKey = `sensor.${tag}_laundry_total_energy`;

  const todayEnergy = useEnergyDay(energyKey);
  const [states, ents] = useStates(keys);

  let state;
  let extra = null;
  state = (
    <span>
      Idle,
      Last run {getAgoString(states.last_run)} ago
    </span>
  );

  if (states.machine_state === 'Run') {
    state = (
      <span>
        {states.cycle} - {states.sub_cycle}
      </span>
    );
    extra = (<pre>{states.time_remaining} left</pre>);

  }

  return (
    <WideAccessoryCard
      // name={'Wide Card. Much typing and text extends across various places wonder how far it will go'}
      // state={'OnState goes here and extends.' /* must not extend past one line */ }
      name={`Laundry (${tag})`}
      state={state}
      isActive={true || states['power'] !== 'off'}
      stale={getStale(ents['machine_state']) + ' ' + parseFloat(states['measured_power']||0).toFixed(0) + 'W'}
      handlePress={() => true}
      extra={extra}
      iconActive={<ImageIcon backgroundColor={'#919ccd'} src={laundry} />}
    />
  );
}


function UPSCard({tag}) {
  const keys = {
    capacity: `sensor.${tag}_ups_nominal_real_power`,
    load: `sensor.${tag}_ups_load`,
    runtime: `sensor.${tag}_ups_battery_runtime`,
    voltage: `sensor.${tag}_ups_input_voltage`,
  };
  const [states, ents] = useStates(keys);
  let minutes = '-';
  let watts = '';
  if (states.runtime) {
    minutes = (states.runtime/60).toFixed(1);
  }
  if (states.load && states.capacity) {
    watts = (parseFloat(states.load)*parseFloat(states.capacity)/100).toFixed(1) + 'W';
  }
  return (
    <AccessoryCard
      name={tag.substring(0,1).toUpperCase() + tag.substring(1).replace(/ing$/,'') + ' UPS'}
      state={states.voltage ? (states.voltage + 'V'):''}
      isActive={true}
      stale={getStale(ents['voltage']) + ' ' + watts}
      handlePress={() => true}
      iconActive={<GenericIcon backgroundColor={'green'} text={minutes} />}
    />

  );
}

export {
  getAgo,
  Alarm,
  AllDoors,
  AllGarageDoors,
  AllLights,
  AllMotions,
  AllRunnings,
  AllWindows,
  Area,
  Climate,
  Entity,
  GenericIcon,
  ImageIcon,
  LEDBar,
  Light,
  LightsCluster,
  Lock,
  ReloadingCameraCard,
  Scene,
  Temperature,
  DishwasherCard,
  LaundryCard,
  WaterHeaterCard,
  UPSCard,
  temperatureToColor,
};
